import React, { useCallback, useEffect, useState } from 'react';
import { toast } from 'react-toastify';
import api from '../api/client';

const inr = (v) => `₹${Number(v).toLocaleString('en-IN', { minimumFractionDigits: 2, maximumFractionDigits: 2 })}`;
const err = (e) => e.response?.data?.detail || 'Something went wrong. Please try again.';

const Resale = () => {
  const [open, setOpen] = useState(null);
  const [mine, setMine] = useState([]);
  const [holdings, setHoldings] = useState([]);
  const [form, setForm] = useState({ spv: '', shares: '', ask_price: '' });

  const load = useCallback(async () => {
    try {
      const [o, m, h] = await Promise.all([api.get('/api/resale/listings/'), api.get('/api/resale/listings/my/'), api.get('/api/holdings/my/')]);
      setOpen(o.data); setMine(m.data); setHoldings(h.data);
    } catch (e) {
      toast.error('Failed to load');
    }
  }, []);
  useEffect(() => { load(); }, [load]);

  const act = async (fn, ok) => { try { await fn(); toast.success(ok); load(); } catch (e) { toast.error(err(e)); } };

  const submit = (e) => {
    e.preventDefault();
    act(() => api.post('/api/resale/listings/', { spv: Number(form.spv), shares: Number(form.shares), ask_price: form.ask_price }), 'Listed. Our team will match and approve a buyer.');
  };

  if (!open) return <main style={{ padding: '4rem 1rem', textAlign: 'center' }}><p>Loading…</p></main>;
  const spvs = [...new Map(holdings.map((h) => [h.spv, h.spv_name])).entries()];
  return (
    <main style={{ maxWidth: 1000, margin: '0 auto', padding: '2rem 1rem' }}>
      <h1>Resale</h1>
      <p>Transfers between investors need approval from the company and keep the number of members within the legal limit. A fee applies and is shown before you confirm.</p>

      <h2>Shares for sale</h2>
      {open.length === 0 ? <p>No listings are open to you right now.</p> : (
        <table style={{ width: '100%' }}>
          <thead><tr><th align="left">Company</th><th align="right">Shares</th><th align="right">Price / share</th><th align="right">You would pay (incl. fee)</th><th /></tr></thead>
          <tbody>{open.map((l) => (
            <tr key={l.id}><td>{l.spv_name}</td><td align="right">{l.shares}</td><td align="right">{inr(l.ask_price)}</td><td align="right">{inr(l.buyer_pays)}</td>
              <td>{l.interested ? 'Interest registered' : <button onClick={() => act(() => api.post(`/api/resale/listings/${l.id}/interest/`), 'Interest registered')}>I am interested</button>}</td></tr>
          ))}</tbody>
        </table>
      )}

      <h2>Sell my shares</h2>
      {spvs.length === 0 ? <p>You do not hold any shares yet.</p> : (
        <form onSubmit={submit} style={{ display: 'flex', gap: 8, flexWrap: 'wrap' }}>
          <select aria-label="Company" value={form.spv} onChange={(e) => setForm({ ...form, spv: e.target.value })} required>
            <option value="">Company…</option>{spvs.map(([id, name]) => <option key={id} value={id}>{name}</option>)}
          </select>
          <input aria-label="Shares" type="number" min="1" step="1" placeholder="Shares" value={form.shares} onChange={(e) => setForm({ ...form, shares: e.target.value })} required />
          <input aria-label="Asking price per share" type="number" min="0" step="0.01" placeholder="Price per share (₹)" value={form.ask_price} onChange={(e) => setForm({ ...form, ask_price: e.target.value })} required />
          <button type="submit">List for sale</button>
        </form>
      )}

      <h2>My listings</h2>
      {mine.length === 0 ? <p>None.</p> : (
        <table style={{ width: '100%' }}>
          <thead><tr><th align="left">Company</th><th align="right">Shares</th><th align="right">You receive (after fee)</th><th align="left">Status</th><th /></tr></thead>
          <tbody>{mine.map((l) => (
            <tr key={l.id}><td>{l.spv_name}</td><td align="right">{l.shares}</td><td align="right">{inr(l.seller_receives)}</td>
              <td>{l.status}{l.status === 'open' && ` · ${l.interest_count} interested`}{l.seller_utr && ` · paid, UTR ${l.seller_utr}`}</td>
              <td>{l.status === 'open' && <button onClick={() => act(() => api.post(`/api/resale/listings/${l.id}/cancel/`), 'Cancelled')}>Cancel</button>}</td></tr>
          ))}</tbody>
        </table>
      )}
    </main>
  );
};

export default Resale;
